import React, { useState, useEffect } from "react";
import api from "../../axiosConfig";
import { Container, Form, Button, Row, Col, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function MijloaceFixeEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    bxnumar_inv: "",
    bxdenumire: "",
    bxstare: false,
    bxdata1: "",
    bxdatascos: "",
    bxvalinv: 0,
    bxcodclas_id: "",
    tip_id: "",
    bxani: 0,
    angajat_id: "",
    bxdescriere: "",
    data_term_am: "",
    details: []
  });

  const [coduri, setCoduri] = useState([]);
  const [tipOp, setTipOp] = useState([]);

  useEffect(() => {
    api.get("/mijloace_fixe/coduri/").then(res => setCoduri(res.data)).catch(console.error);
    api.get("/mijloace_fixe/tip_op/").then(res => setTipOp(res.data)).catch(console.error);
  }, []);

  useEffect(() => {
    api.get(`/mijloace_fixe/${id}`)
      .then(res => {
        const data = res.data;
        if (data.bxdata1) data.bxdata1 = data.bxdata1.split('T')[0];
        if (data.bxdatascos) data.bxdatascos = data.bxdatascos.split('T')[0];
        if (data.data_term_am) data.data_term_am = data.data_term_am.split('T')[0];
        data.bxstare = data.bxstare === "1" || data.bxstare === true;
        
        if (data.details) {
            data.details = data.details.map(d => {
                if (d.bxdata) d.bxdata = d.bxdata.split('T')[0];
                return d;
            });
        } else {
            data.details = [];
        }

        setFormData(data);
      })
      .catch(err => {
        console.error(err);
        toast.error("Eroare la încărcarea datelor.");
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDetailChange = (index, field, value) => {
    const newDetails = [...formData.details];
    newDetails[index][field] = value;
    setFormData({ ...formData, details: newDetails });
  };

  const addDetailRow = () => {
    setFormData({
      ...formData,
      details: [
        ...formData.details,
        { bxtipopmf_id: "", bxdata: "", bxdebit: 0, bxcredit: 0, bxamltrans: 0 }
      ]
    });
  };

  const removeDetailRow = (index) => {
    const newDetails = formData.details.filter((_, i) => i !== index);
    setFormData({ ...formData, details: newDetails });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...formData };
      if (!payload.bxdata1) delete payload.bxdata1;
      if (!payload.bxdatascos) delete payload.bxdatascos;
      if (!payload.data_term_am) delete payload.data_term_am;

      payload.bxstare = payload.bxstare ? "1" : "0";

      // Clean empty strings for optional int/float fields
      const fieldsToClean = ["tip_id", "bxcodclas_id", "bxani", "bxvalinv"];
      fieldsToClean.forEach(f => {
        if (payload[f] === "") {
          payload[f] = null;
        }
      });

      payload.details = payload.details.map(d => {
        let cleanD = { ...d };
        if (!cleanD.bxdata) delete cleanD.bxdata;
        if (!cleanD.bxtipopmf_id || cleanD.bxtipopmf_id === "") cleanD.bxtipopmf_id = 0;
        return cleanD;
      });

      await api.put(`/mijloace_fixe/${id}`, payload);
      toast.success("Mijloc fix actualizat cu succes!");
      navigate("/mijloace-fixe");
    } catch (err) {
      console.error(err);
      toast.error("Eroare la actualizarea mijlocului fix.");
    }
  };

  return (
    <Container className="mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Editare Mijloace Fixe</h4>
        </div>
        <div className="card-body">
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Număr inventar</Form.Label>
                  <Form.Control type="text" name="bxnumar_inv" value={formData.bxnumar_inv || ""} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Denumire</Form.Label>
                  <Form.Control type="text" name="bxdenumire" required value={formData.bxdenumire || ""} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={3} className="d-flex align-items-end pb-2">
                <Form.Check type="checkbox" label="Stare *" name="bxstare" checked={formData.bxstare} onChange={handleChange} />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Data intrare *</Form.Label>
                  <Form.Control type="date" name="bxdata1" value={formData.bxdata1 || ""} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Data scoatere *</Form.Label>
                  <Form.Control type="date" name="bxdatascos" value={formData.bxdatascos || ""} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Valoare de inventar</Form.Label>
                  <Form.Control type="number" step="0.01" name="bxvalinv" value={formData.bxvalinv || 0} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Ani amortizare</Form.Label>
                  <Form.Control type="number" step="0.1" name="bxani" value={formData.bxani || 0} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Cod Clasificare</Form.Label>
                  <Form.Select name="bxcodclas_id" value={formData.bxcodclas_id || ""} onChange={handleChange}>
                    <option value="">-- Selectează cod --</option>
                    {coduri.map(c => (
                      <option key={c.bxid} value={c.bxid}>{c.bxcod} - {c.bxdescr}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Tip</Form.Label>
                  <Form.Control type="text" name="tip_id" value={formData.tip_id || ""} onChange={handleChange} placeholder="Manual ID" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Data termen terminare amortizare *</Form.Label>
                  <Form.Control type="date" name="data_term_am" value={formData.data_term_am || ""} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Descriere</Form.Label>
                  <Form.Control as="textarea" rows={2} name="bxdescriere" value={formData.bxdescriere || ""} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>

            <h5 className="mt-4">Linii (Detalii)</h5>
            <Table bordered hover size="sm">
              <thead className="bg-light">
                <tr>
                  <th>Tip Operație</th>
                  <th>Data</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Amortizare transferată</th>
                  <th>Acțiune</th>
                </tr>
              </thead>
              <tbody>
                {formData.details.map((detail, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Select value={detail.bxtipopmf_id || ""} onChange={(e) => handleDetailChange(index, "bxtipopmf_id", e.target.value)}>
                        <option value="">-- Selectează --</option>
                        {tipOp.map(op => (
                          <option key={op.id} value={op.id}>{op.denumire}</option>
                        ))}
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Control type="date" value={detail.bxdata || ""} onChange={(e) => handleDetailChange(index, "bxdata", e.target.value)} />
                    </td>
                    <td>
                      <Form.Control type="number" step="0.01" value={detail.bxdebit || 0} onChange={(e) => handleDetailChange(index, "bxdebit", e.target.value)} />
                    </td>
                    <td>
                      <Form.Control type="number" step="0.01" value={detail.bxcredit || 0} onChange={(e) => handleDetailChange(index, "bxcredit", e.target.value)} />
                    </td>
                    <td>
                      <Form.Control type="number" step="0.01" value={detail.bxamltrans || 0} onChange={(e) => handleDetailChange(index, "bxamltrans", e.target.value)} />
                    </td>
                    <td>
                      <Button variant="danger" size="sm" onClick={() => removeDetailRow(index)}>Șterge</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="6">
                    <Button variant="success" size="sm" onClick={addDetailRow}>[+] Adaugă linie</Button>
                  </td>
                </tr>
              </tfoot>
            </Table>

            <div className="mt-4 text-end">
              <Button variant="success" type="submit" className="me-2">Actualizează</Button>
              <Button variant="danger" onClick={() => navigate("/mijloace-fixe")}>Înapoi</Button>
            </div>
          </Form>
        </div>
      </div>
    </Container>
  );
}

export default MijloaceFixeEdit;
